import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { atomFamily } from 'jotai-family';
import { atomWithLazy } from 'jotai/utils';
import { EntityType } from '../../data-models/field2.data-model';
import { RubricConfig } from '../../schemas/Rubric.schema';
import { queryClient } from '../MaggieQueryClient';
import { getRubricConfig, getRubrics } from '../queries/MaggieRubricQueries';

export const RubricConfigQueryKey = 'rubricConfig';

export const rubricConfigAtom = atomWithLazy<Promise<RubricConfig[]> | RubricConfig[]>(() =>
  getRubricConfig()
);

export const rubricConfigByIdAtom = atom(async (get) => {
  const rubricConfig = await get(rubricConfigAtom);
  return rubricConfig?.reduce((acc, config) => {
    return acc.set(config.id, config);
  }, new Map<number, RubricConfig>());
});

type IRubricsByCompanyIdKey = {
  companyId: number;
  date: string;
};

export const mostRecentRubricsByCompanyIdAtom = atomFamily(
  (key: IRubricsByCompanyIdKey) =>
    atomWithSuspenseQuery(() => {
      return {
        queryKey: [
          'mostRecentRubricsByCompanyIdAtom',
          { entity: EntityType.company, entityId: key.companyId, date: key.date },
        ],
        queryFn: async () => {
          return await getRubrics({ entityId: key.companyId, entity: EntityType.company, date: key.date });
        },
      };
    }),
  (key1, key2) => key1.companyId == key2.companyId && key1.date == key2.date
);

export async function invalidateMostRecentRubricsByCompanyIdAtom(companyId: number) {
  await queryClient.invalidateQueries({
    queryKey: ['mostRecentRubricsByCompanyIdAtom', { entity: EntityType.company, entityId: companyId }],
  });
}
